export default __webpack_public_path__ + "static/media/arrowleft.26090565.gif";